export enum TipoEnsaioEnum {
  CALCINACAO = 'CALCINACAO',
  CARBONO = 'CARBONO',
  FRX = 'FRX',
  FRX_QUALITATIVO = 'FRX_QUALITATIVO',
  GRAVIMETRIA = 'GRAVIMETRIA',
  ICP = 'ICP',
  ICP_COBRE = 'ICP_COBRE',
  UMIDADE = 'UMIDADE',
  UMIDADE_BALANCA = 'UMIDADE_BALANCA',
}

export enum TipoEnsaioMetodoEnum {
  CALCINACAO = 'CALCINACAO',
  CARBONO = 'CARBONO',
  FRX = 'FRX',
  FRX_QUALITATIVO = 'FRX_QUALITATIVO',
  GRAVIMETRIA = 'GRAVIMETRIA',
  ICP = 'ICP',
  ICP_COBRE = 'ICP_COBRE',
  UMIDADE_ESTUFA = 'UMIDADE_ESTUFA',
  UMIDADE_BALANCA = 'UMIDADE_BALANCA',
}
